import { useQuery } from "@tanstack/react-query";

import { pricingApi } from "@/lib/api";

/**
 * Daftar harga layanan coach (`coach_commercial_prices`). Data jarang berubah
 * (merchant yang mengisi), jadi di-cache 5 menit supaya membuka menu tidak
 * selalu memukul API.
 */
export function useCoachPricing() {
    return useQuery({
        queryKey: ["coach-pricing"],
        queryFn: ({ signal }) => pricingApi.list(signal),
        staleTime: 5 * 60 * 1000,
    });
}
